import { config } from "./config";
// @ts-ignore
import useApi from "./ServiceClient.tsx";

export const useGlobalUsers = () => {
  const { GET, POST, DELETE, globleRequest } = useApi(); // Use API methods inside a React hook

  const getGlobalUser = () => {
    const response = GET(config?.user_management?.END_POINTS?.GLOBAL_USER);
    return response;
  };

  const createGlobalUsers = (objectId, token) => {
    const response = globleRequest(`${config?.user_management?.BASE_URL}${config?.user_management?.END_POINTS?.GLOBAL_USER_CREATE}/${objectId}`, objectId, objectId, null, token);
    return response;
  };

  const updateGlobalUsers = (data) => {
    const response = POST(
      config?.user_management?.END_POINTS?.GLOBAL_USER_UPDATE,
      data
    );
    return response;
  };

  const deleteGlobalUsers = (userid) => {
    const response = DELETE(
      `${config?.user_management?.END_POINTS?.GLOBAL_USER_DELETE}/${userid}`
    );
    return response;
  };

  const searchUsers = (email) => {
    const response = GET(
      `${config?.user_management?.END_POINTS?.SEARCH_USER}/${email}?userEmail=${email}`
    );
    return response;
  };

  const getUsersStatistics = (tenantid) => {
    const response = GET(
      `${config?.user_management?.END_POINTS?.TENANT_USER_STAT}/${tenantid}`
    );
    return response;
  };

  const getUsers = async (tenantId, queryParam) => {
    const response = GET(
      `${config?.intivation_management?.END_POINTS?.GET_INVITES_BY_TENANT}/${tenantId}?${queryParam}=true`
    );
    return response;
  };

  const createADUser = (data) => {
    const response = POST(
      config?.user_management?.END_POINTS?.CREATE_AD_USER,
      data
    );
    return response;
  };

  const getTenantUsers = (tenantId) => {
    const response = GET(
      `${config?.user_management?.END_POINTS?.TENANT_USERS}/${tenantId}`
    );
    return response;
  };

  return {
    getGlobalUser,
    createGlobalUsers,
    updateGlobalUsers,
    deleteGlobalUsers,
    searchUsers,
    getUsers,
    getUsersStatistics,
    createADUser,
    getTenantUsers
  };
};
